import BaseButtonSplit from '../../sisu/button/BaseButtonSplit.sisu';

const NeoButtonSplit = (props) => {
    return (
        <BaseButtonSplit {...props}/>
    );
};

export default NeoButtonSplit;